import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const attendRegisterListSelector = createSelector(
  (state: RootState) => state.attendRegister.attendRegisterList,
  (attendRegisterList) => attendRegisterList,
);

export const sheetListSelector = createSelector(
  (state: RootState) => state.attendRegister.sheetList,
  (sheetList) => sheetList,
);

export const yearSelector = createSelector(
  (state: RootState) => state.attendRegister,
  (item) => item.year,
);

export const monthSelector = createSelector(
  (state: RootState) => state.attendRegister,
  (item) => item.month,
);
